import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=274fe3fb&scoped=true&"
import script from "./Transactions.vue?vue&type=script&lang=js&"
export * from "./Transactions.vue?vue&type=script&lang=js&"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=274fe3fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274fe3fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274fe3fb')) {
      api.createRecord('274fe3fb', component.options)
    } else {
      api.reload('274fe3fb', component.options)
    }
    module.hot.accept("./Transactions.vue?vue&type=template&id=274fe3fb&scoped=true&", function () {
      api.rerender('274fe3fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/Transactions.vue"
export default component.exports